import React from "react";
import ButtonLoader from "@components/ui/Loaders/ButtonLoader";
import { toast } from "react-toastify";
import useMediaQueryHook from "@hooks/useMediaQueryHook";
import { useTranslation } from "react-i18next";
import Timer from "@components/ui/Timer";
import { useDispatch, useSelector } from "react-redux";
import { setFieldsData } from "Redux/slices/selectedFieldSlice";

const NavigationButtons = ({
  currentStep,
  steps,
  loading,
  isAdviceLoading,
  validateStep,
  setCurrentStep,
  handleSubmit,
  exerciseCategories = false,
  isValid = true,
  sleepCoach = false,
  selectedTags = null,
  //   isMobile = false,
}) => {
  const dispatch = useDispatch();
  const { isMobile } = useMediaQueryHook();
  const { t } = useTranslation();
  const handleNext = () => {
    if (!exerciseCategories) {
      if (validateStep()) {
        dispatch(
          setFieldsData(selectedTags)
        );
        setCurrentStep((prev) => prev + 1);
      } else {
        toast.error(t("toast.oopsIncorrect"));
      }
    } else {
      if (isValid) {
        setCurrentStep((prev) => prev + 1);
      } else {
        toast.error(t("toast.selectOne"));
      }
    }
  };

  const handleBack = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 0));
  };

  return (
    <div
      className={`${
        isMobile
          ? "flex justify-center md:hidden"
          : "hidden md:flex justify-center"
      }`}
    >
      <div className="grid sm:grid-cols-2 gap-[15px] w-full justify-items-end mt-3">
        {currentStep > 0 && (
          <button
            onClick={handleBack}
            className={`px-4 py-[10px] bg-gray-300 text-gray-800 rounded-md w-[100%] ${
              currentStep === 0 && "invisible"
            } ${
              loading || isAdviceLoading ? "opacity-70 pointer-events-none" : ""
            }`}
          >
            {t("firstFormSteps.navigationButtons.back")}
          </button>
        )}

        {currentStep < steps.length - 1 ? (
          <button
            onClick={handleNext}
            className={`px-4 py-[10px] bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white rounded-md w-full ${
              currentStep === 0 && "col-span-2"
            }
            ${
              loading || isAdviceLoading ? "opacity-70 pointer-events-none" : ""
            }
            `}
            disabled={loading}
          >
            {t("firstFormSteps.navigationButtons.next")}
          </button>
        ) : (
          <button
            onClick={() => {
              if (validateStep()) {
                handleSubmit();
              } else {
                toast.error(t("toast.oopsIncorrect"));
              }
            }}
            className={`px-4 py-[10px] bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white rounded-md w-full ${
              loading || isAdviceLoading ? "opacity-70 pointer-events-none" : ""
            }`}
            disabled={loading}
          >
            {loading ? (
              sleepCoach ? (
                <Timer />
              ) : (
                <ButtonLoader />
              )
            ) : (
              t("firstFormSteps.navigationButtons.submit")
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default NavigationButtons;
